import { http, createConfig, createStorage } from 'wagmi';
import { base, baseSepolia } from 'wagmi/chains';
import { coinbaseWallet, injected } from 'wagmi/connectors';

// Determine if we're in production or development
const isDevelopment = process.env.NODE_ENV === 'development';

// Build connectors array
const connectors = [
  // Coinbase Wallet - Primary connector
  coinbaseWallet({
    appName: 'Heritage Ventures - Histocracy',
    appLogoUrl: 'https://www.heritageventures.io/logo.png',
    preference: 'smartWalletOnly', // Prefer Coinbase Smart Wallet
    version: '4',
  }),
  // Injected wallets (MetaMask, Brave Wallet, etc.) - Fallback
  injected({
    target: 'metaMask',
  }),
];

// NOTE: WalletConnect temporarily disabled due to type compatibility issues with Wagmi v2
// To re-enable: upgrade to wagmi v3 or wait for @walletconnect/ethereum-provider compatibility fix

export const config = createConfig({
  chains: isDevelopment ? [baseSepolia, base] : [base, baseSepolia],
  connectors,
  transports: {
    [base.id]: http(),
    [baseSepolia.id]: http(),
  },
  // Enable auto-reconnect and persistence
  ssr: false,
  storage: createStorage({
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  }),
});

// Re-export chains for easy access
export { base, baseSepolia };
